/**
 * 404 — в legacy Main::error рендерит ТОТ ЖЕ main_index.tpl, что и главная,
 * но со списком слайдов = [] и материалом 'error_404': остаются <br> и текст.
 *
 * Пустой .rtSlider тут не рисуется: в legacy шаблон его выводил, но rtSlider.js
 * сразу удалял блок, если слайдов нет ($(".rtSlider").remove()). Оставить его —
 * значит показать 400 px пустоты над текстом, чего на боевом сайте не видно.
 */

import type { Material } from '@/api/types'
import { useApi } from '@/lib/useApi'

export function NotFoundPage() {
  const { data } = useApi<{ material: Material | null }>('/api/content/error404')

  return (
    <>
      <br />
      {data?.material != null && <div dangerouslySetInnerHTML={{ __html: data.material.text }} />}
    </>
  )
}
